import { render, staticRenderFns } from "./icon-danger.vue?vue&type=template&id=6b7ce3b1&scoped=true&"
import script from "./icon-danger.vue?vue&type=script&lang=js&"
export * from "./icon-danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ce3b1",
  null
  
)

export default component.exports